import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ISetup} from "../../interface/redux/ISetup";

const initialState: ISetup = {
    language: 'sk',
    theme: window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light",
};

const setupSlice = createSlice({
    name: 'setup',
    initialState,
    reducers: {
        updateSetup(state, action: PayloadAction<Partial<ISetup>>) {
            Object.keys(action.payload).forEach((key) => {
                state[key] = action.payload[key];
            });
        }
    },
});

export const { updateSetup } = setupSlice.actions;

export default setupSlice.reducer;


